import { render, staticRenderFns } from "./BVFooter.vue?vue&type=template&id=5640377a&scoped=true&"
import script from "./BVFooter.vue?vue&type=script&lang=js&"
export * from "./BVFooter.vue?vue&type=script&lang=js&"
import style0 from "./BVFooter.vue?vue&type=style&index=0&id=5640377a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640377a",
  null
  
)

export default component.exports